/* eslint-disable import/prefer-default-export */
/* eslint-disable consistent-return */
import { loaderService } from 'src/services/loaderService';
import { apileads } from '../enviroment/apileads';

const getVehiculos = async () => {
  const response = await apileads.get('/v1/vehiculos-lucia');
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log('Error get List ');
  }
};

const putVehiculos  = async (params) => {
  console.log(params, 'params')
  loaderService.show();

  const body = {
    id: parseInt(params.id),
    linea: params.linea,
    marca: params.marca,
    unidad_negocio_id: parseInt(params.unidad_negocio_id),
    estado: parseInt(params.estado)
  }

  const response = await apileads.put('/v1/vehiculos', body);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error, 'Error al Actualizar');
  }
}


const postVehiculos = async (params) => {
  const body = {
    linea: params.linea,
    marca: params.marca,
    unidad_negocio_id: parseInt(params.unidad_negocio_id),
    estado: params.estado
  }

  loaderService.show();
  const response = await apileads.post('/v1/vehiculos', body);
  try {
    if (response.status === 200) {
      //console.log(response)
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error, 'Error al Postear');
  }
};

const deleteVehiculo = async (id) => {
  const response = await apileads.delete(`/v1/vehiculos?id=${id}`);
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};


export {
  getVehiculos,
  postVehiculos,
  putVehiculos,
  deleteVehiculo
};
